import React, { useState, useEffect } from 'react';
import apiClient from '../services/apiClient';
import moment from 'moment';

const LoginActivityPanel = () => {
    const [entries, setEntries] = useState([]);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(1);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchHistory();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    const fetchHistory = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('token');
            const response = await apiClient.get('/login-history', {
                params: { page, limit: 50 },
                headers: { Authorization: `Bearer ${token}` }
            });
            setEntries(response.data.entries);
            setPages(response.data.pages);
        } catch (error) {
            console.error('Failed to fetch login history:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div>Loading...</div>;

    return (
        <div className="p-4 md:p-6 bg-white shadow-md rounded-lg max-w-full overflow-hidden">
            <div className="flex items-center justify-center gap-3 mb-6">
                <div className="h-8 w-2 bg-purple-500 rounded-full"></div>
                <h2 className="text-2xl md:text-3xl font-bold text-gray-800 tracking-tight text-center">Login Activity</h2>
            </div>

            <div className="overflow-x-auto">
                <table className="w-full text-left border-collapse">
                    <thead>
                        <tr className="bg-gray-100 border-b">
                            <th className="p-3 font-semibold">User</th>
                            <th className="p-3 font-semibold">Role</th>
                            <th className="p-3 font-semibold">When</th>
                            <th className="p-3 font-semibold">IP</th>
                            <th className="p-3 font-semibold">Location</th>
                            <th className="p-3 font-semibold">Flag</th>
                        </tr>
                    </thead>
                    <tbody>
                        {entries.map(entry => (
                            <tr key={entry._id} className="border-b hover:bg-gray-50">
                                <td className="p-3 text-sm">{entry.user?.name}<br /><span className="text-xs text-gray-500">{entry.user?.email}</span></td>
                                <td className="p-3 text-sm capitalize">{entry.role}</td>
                                <td className="p-3 text-sm">{moment(entry.loginAt).format('DD MMM YYYY, h:mm a')}</td>
                                <td className="p-3 text-sm font-mono">{entry.ip || '—'}</td>
                                <td className="p-3 text-sm">
                                    {entry.location?.city || entry.location?.country
                                        ? [entry.location.city, entry.location.region, entry.location.country].filter(Boolean).join(', ')
                                        : (entry.location?.latitude ? `${entry.location.latitude.toFixed(3)}, ${entry.location.longitude.toFixed(3)}` : '—')}
                                    {entry.location?.latitude && entry.location?.longitude && (
                                        <a
                                            href={`https://www.google.com/maps?q=${entry.location.latitude},${entry.location.longitude}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="ml-2 text-blue-600 hover:underline text-xs"
                                        >
                                            map
                                        </a>
                                    )}
                                </td>
                                <td className="p-3">
                                    {entry.isLikelyVpn ? (
                                        <span className="px-2 py-1 rounded text-xs font-bold bg-orange-100 text-orange-700">VPN/PROXY?</span>
                                    ) : (
                                        <span className="text-xs text-gray-300">—</span>
                                    )}
                                </td>
                            </tr>
                        ))}
                        {entries.length === 0 && (
                            <tr><td colSpan="6" className="p-4 text-center text-gray-500">No login activity recorded yet</td></tr>
                        )}
                    </tbody>
                </table>
            </div>

            {pages > 1 && (
                <div className="flex justify-center gap-2 mt-6">
                    <button
                        onClick={() => setPage(p => Math.max(1, p - 1))}
                        disabled={page <= 1}
                        className="px-3 py-1.5 rounded border text-sm disabled:opacity-40"
                    >
                        Prev
                    </button>
                    <span className="px-3 py-1.5 text-sm text-gray-600">Page {page} of {pages}</span>
                    <button
                        onClick={() => setPage(p => Math.min(pages, p + 1))}
                        disabled={page >= pages}
                        className="px-3 py-1.5 rounded border text-sm disabled:opacity-40"
                    >
                        Next
                    </button>
                </div>
            )}
        </div>
    );
};

export default LoginActivityPanel;
